/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import ChainingServiceFoundSelector from './ChainingServiceFoundSelector.vue'

export * from './ChainingServiceFoundSelector'
export default ChainingServiceFoundSelector
